// Triple Whale Analytics Constants

export const TRIPLE_WHALE_ROUTES = {
    ANALYTICS: '/analytics/triplewhale'
};

export const TRIPLE_WHALE_API = {
    ENDPOINTS: {
        SUMMARY: '/api/v1/triplewhale/summary'
    }
};

export const TRIPLE_WHALE_ROLES = ['ADMIN', 'FINANCE'];

export const TRIPLE_WHALE_TABLE_COLUMNS = {
    HOUR: 'hour',
    AD_SPEND: 'adSpend',
    NET_REVENUE: 'netRevenue',
    EROAS: 'eroas',
    HOURLY_CONTRIBUTION: 'hourlyContribution',
    TOTAL_SPEND: 'totalSpend',
    TOTAL_REVENUE: 'totalRevenue',
    TOTAL_ROAS: 'totalRoas',
    TOTAL_CONTRIBUTION: 'totalContribution',
    TIMESTAMP: 'timestamp',
    COMMENTS: 'comments'
};

export const TRIPLE_WHALE_STATES = {
    LOADING: 'loading',
    SUCCESS: 'success',
    ERROR: 'error',
    IDLE: 'idle'
};

export const TRIPLE_WHALE_DATE_FORMAT = 'YYYY-MM-DD';

export const TRIPLE_WHALE_CURRENCY_FORMAT = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
};

// Baseline efficiency ROAS used for contribution calculations
export const TRIPLE_WHALE_BEROAS = 1.28;